module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/governmentForms/LHDNFiles.ejs -->\n';
 var moment = require('moment') 
__p+='\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2 class="govt-forms-title">LHDN Audit Files</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content">\n    <div class="row">\n        <div class="col-sm-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-content">\n                    <div class="row vertical-align">\n                        <div class="col-sm-1 text-center">\n                            <i class="fa fa-2x fa-info-circle m-t-sm"></i>\n                        </div>\n                        <h3 class="col-sm-11 line-height-md">\n                            Please be reminded to check the forms as it is the\n                            employer\'s responsibility to provide accurate\n                            information.\n                        </h3>\n                    </div>\n                </div>\n            </div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    ';
 if (collection.length <= 0) { 
__p+='\n                        <h5>No Files Available</h5>\n                    ';
 } else if (collection.length === 1) { 
__p+='\n                        <h5>'+
((__t=( collection.length ))==null?'':_.escape(__t))+
' LHDN Audit Files</h5>\n                    ';
 } else if (collection.length > 1) { 
__p+='\n                        <h5>'+
((__t=( collection.length ))==null?'':_.escape(__t))+
' LHDN Audit Files</h5>\n                    ';
 } 
__p+='\n                </div>\n\n                <div class="ibox-content">\n                    <div class="row items">\n                        <div class="col-xs-12">\n                            '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n\n                            <div class="empty-list text-center hidden">\n                                <h1>\n                                    You haven\'t generated LHDN audit files yet.\n                                </h1>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="ibox-footer text-right">\n                    <select name="period-year">\n                        ';

                        var latestYear = 2025;
                        for (
                            var y = (moment(app.company.get('createdAt') || new Date())).year();
                            y <= latestYear;
                            y ++
                        ) { 
__p+='\n                            <option value="'+
((__t=(y))==null?'':_.escape(__t))+
'" '+
((__t=( y === latestYear ? 'selected' : '' ))==null?'':_.escape(__t))+
'>'+
((__t=(y))==null?'':_.escape(__t))+
'</option>\n                        ';
 } 
__p+='\n                    </select>\n                    <button class="btn btn-primary js-generate">\n                        Generate Files\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/governmentForms/LHDNFiles.ejs
// module id = 919
// module chunks = 1